import { defineMessage } from 'services/localization';

export const messages = {
    salesDetailsSection: defineMessage('sales_details'),
    shippingDetailsSection: defineMessage('shipping_details_1'),
    salesRep: defineMessage('sales_rep_1'),
    opportunity: defineMessage('opportunity'),
    salesEffectiveDate: defineMessage('sales_effective_date'),
    excludeCommissions: defineMessage('exclude_commissions'),
    leadSource: defineMessage('lead_source'),
    partner: defineMessage('partner'),
    shipDate: defineMessage('shipping_date'),
    shipMethod: defineMessage('shipping_method'),
    shippingAddress: defineMessage('shipping_address'),
    positiveBooleanValue: defineMessage('yes'),
};
